import { ProjectDocStatusVals } from "./ProjectDocStatusVals";

// Только статусы, видимые подрядчику (бэкенд ProjectDocService.SecureQueryByContractorOwnedAndStatuses) -
// остальные статусы словаря ProjectDocStatuses контрагенту никогда не приходят, поэтому в фильтре не нужны.
// Подписи - дословно Title из бэкенда (X5.PDA.DAL/Configs/ProjectDocStatusConfig.cs).
export const projectDocStatusFilterOptions = [
  { label: `Разработка`, value: ProjectDocStatusVals.Development },
  { label: `Подтверждение завершения согласования`, value: ProjectDocStatusVals.CompletingConfirmation },
  { label: `Согласовано`, value: ProjectDocStatusVals.Approved },
  { label: `Остановлено`, value: ProjectDocStatusVals.Stopped },
  { label: `Утверждено`, value: ProjectDocStatusVals.Affirmed },
  { label: `Отправка в архив`, value: ProjectDocStatusVals.SendingToArchive },
  { label: `Принято в архив`, value: ProjectDocStatusVals.ApprovedByArchivarius },
  { label: `Завершено`, value: ProjectDocStatusVals.Finished },
];
